import React from 'react';
import type { SelectedProductSegmentAppeal } from '../../redux/chat/chatSlice';

interface SelectedProductTagProps {
  product: {
    id: number;
    name: string;
    segmentAppeal?: SelectedProductSegmentAppeal | null;
  };
  onRemove: () => void;
}

const SelectedProductTag: React.FC<SelectedProductTagProps> = ({ product, onRemove }) => {
  const segmentAppeal = product.segmentAppeal;
  return (
    <div className="inline-flex max-w-full items-center gap-2 px-3 py-1.5 bg-green-100 text-green-700 border border-green-300 rounded-full text-sm">
      <span>📦</span>
      <span className="shrink-0">商品選択 ({product.name})</span>
      {/* 「誰に、何を伝えるか」を選んだときだけ、小さく添える。 */}
      {segmentAppeal && (
        <span
          className="min-w-0 truncate rounded bg-violet-100 px-1.5 py-0.5 text-xs font-medium text-violet-700"
          title={segmentAppeal.appealDirection || undefined}
        >
          {segmentAppeal.segmentName} / {segmentAppeal.appealName}
        </span>
      )}
      <button
        onClick={onRemove}
        className="ml-1 hover:bg-green-200 rounded-full p-0.5 w-4 h-4 flex items-center justify-center text-xs transition-colors"
        aria-label="商品選択を解除"
      >
        ×
      </button>
    </div>
  );
};

export default SelectedProductTag;
